import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PlaybookUsageQuery$variables } from './__generated__/PlaybookUsageQuery.graphql';
import PlaybookUsageQuery$parameters from './__generated__/PlaybookUsageQuery$parameters';

export const playbookUsageEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		import(/* webpackChunkName: "async-playbooks-usage" */ './PlaybookUsage').then(
			(module) => module.PlaybookUsage,
		),
	),
	getPreloadProps: (variables: PlaybookUsageQuery$variables) => {
		return {
			queries: {
				PlaybookUsageQuery: {
					parameters: PlaybookUsageQuery$parameters,
					variables,
				},
			},
		};
	},
});
